import script from "./OrderManageView.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderManageView.vue?vue&type=script&lang=ts&setup=true"

import "./OrderManageView.vue?vue&type=style&index=0&id=6bcd8ef6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bcd8ef6"]])

export default __exports__